// extracted by mini-css-extract-plugin
module.exports = {"color-keyline-grey":"#C2C2C2","colorKeylineGrey":"#C2C2C2","color-white":"#FFFFFF","colorWhite":"#FFFFFF","orContainer":"_21K0P","or":"UgLWN","continueOnRetailer":"_33sXP"};